export class MtaServerError {
  public message: string;
  public detail: string;

  constructor(error: any) {
    const e = error || {};

    if (typeof e === 'string') {
      this.message = e;
      this.detail = '';
      return;
    }

    this.message = e.Message || e.message || e.Title || e.title || '';
    this.detail  = e.Detail  || e.detail  || e.title || '';

    if (!this.message) {
      // Try validation errors object (ASP.NET model state)
      if (e.errors) {
        const msgs: string[] = [];
        const errs = e.errors;
        if (Array.isArray(errs)) {
          msgs.push(...errs);
        } else {
          Object.values(errs).forEach((v: any) => {
            if (Array.isArray(v)) { msgs.push(...v); }
            else if (typeof v === 'string') { msgs.push(v); }
          });
        }
        this.message = msgs.join(' ');
      }
    }
  }
}
